<template>
  <div class="issued_policy">
    <div class="container" style="min-height: 450px;  margin-top: 2em;margin-bottom: 2em;">
      <div class="row">
        <div v-if="applicationInfo" class="col-sm-12">
          <h3>เลขที่ใบคำขอ : {{ _.get(applicationInfo, 'applicationId') }}</h3>

          <div class="application-information">
            <table class="appliciation-information-table table">
              <tr class="information-table-row">
                <td class="information-table-data">เลขที่ใบคำขอ PV :</td>
                <td class="information-table-data">
                  {{ _.get(applicationInfo, 'pvApplicationNumber') || 'ไม่พบข้อมูล' }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">เลขกรมธรรม์ :</td>
                <td class="information-table-data">
                  {{ _.get(applicationInfo, 'policyNumber') || 'ไม่พบข้อมูล' }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">เป็นลูกค้าเก่า Genarali :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'isOldGeneraliClient') ? 'ใช่' : 'ไม่ใช่' }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ชื่อ :</td>
                <td class="information-table-data">
                  <p>
                    {{ _.get(insuredPersonInfo, 'title.name') }}
                    {{ _.get(insuredPersonInfo, 'firstname') }}
                    {{ _.get(insuredPersonInfo, 'lastname') }}
                  </p>
                  <p>
                    {{ _.get(insuredPersonInfo, 'identityTypeName') }}
                    {{ _.get(insuredPersonInfo, 'identityNumber') }}
                  </p>
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">วันเกิด :</td>
                <td class="information-table-data">
                  <p>วันเกิด : {{ _.get(insuredPersonInfo, 'birthDate') }}</p>
                  <p>อายุ : {{ _.get(insuredPersonInfo, 'age') }} ปี</p>
                  <p>เพศ : {{ _.get(insuredPersonInfo, 'sex') === 'M' ? 'ชาย' : 'หญิง' }}</p>
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">อาชีพ :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'occupation.nameTh') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ส่วนสูง :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'height') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">น้ำหนัก :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'weight') }}
                </td>
              </tr>

              <tr class="information-table-row">
                <td class="information-table-data">เบอร์โทรศัพท์ :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'mainMobileTel') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">อีเมล์ :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'email') || '-' }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ที่อยู่ตามทะเบียนบ้าน :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'mainAddress') }}
                  {{ _.get(insuredPersonInfo, 'mainSoiRoad') }}
                  {{ _.get(insuredPersonInfo, 'mainTambon.name') }}
                  {{ _.get(insuredPersonInfo, 'mainAmphoe.name') }}
                  {{ _.get(insuredPersonInfo, 'mainProvince.name') }}
                  {{ _.get(insuredPersonInfo, 'mainTambon.postcode') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ที่อยู่ที่สะดวกติดต่อ :</td>
                <td class="information-table-data">
                  {{ _.get(insuredPersonInfo, 'deliveryAddress') }}
                  {{ _.get(insuredPersonInfo, 'deliverySoiRoad') }}
                  {{ _.get(insuredPersonInfo, 'deliveryTambon.name') }}
                  {{ _.get(insuredPersonInfo, 'deliveryAmphoe.name') }}
                  {{ _.get(insuredPersonInfo, 'deliveryProvince.name') }}
                  {{ _.get(insuredPersonInfo, 'deliveryTambon.postcode') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">คำถามสุขภาพ :</td>
                <td class="information-table-data">
                  <div
                    class="health-question"
                    v-for="healthAnswer in healthAnswerInfo"
                    :key="healthAnswer.index"
                  >
                    {{ healthAnswer.question }}
                    <span class="highlight">{{ healthAnswer.answer }}</span>
                  </div>
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">แผนที่เลือก :</td>
                <td class="information-table-data">
                  {{ _.get(planPackageSchemeInfo, 'planName') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ความคุ้มครอง :</td>
                <td class="information-table-data">
                  {{ _.get(planPackageSchemeInfo, 'coverageCode') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">วันเริ่มความคุ้มครอง :</td>
                <td class="information-table-data">
                  {{ _.get(applicationInfo, 'policyStartDate') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">Consent Insured :</td>
                <td class="information-table-data">
                  <img
                    class="consent-image"
                    :src="`data:image/png;base64, ${consentInsuredInformation}`"
                    v-if="consentInsuredInformation"
                  />
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">Consent Payer :</td>
                <td class="information-table-data">
                  <img
                    class="consent-image"
                    :src="`data:image/png;base64, ${consentPayerInformation}`"
                    v-if="consentPayerInformation"
                  />
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ช่องทางการชำระเงิน :</td>
                <td class="information-table-data">
                  {{ _.get(paymentInfo, 'paymentType') }}
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ราคาเบี้ยประกัน :</td>
                <td class="information-table-data">
                  {{ _.get(pricingInfo, 'grossPremium') | formatNumber }} บาท
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ส่วนลดค่าใช้จ่ายส่วนแรก :</td>
                <td class="information-table-data">
                  {{ _.get(pricingInfo, 'deductDiscount') | formatNumber }} บาท
                </td>
              </tr>
              <tr class="information-table-row" v-if="isHasFamilyQuotation">
                <td class="information-table-data">ส่วนลดเบี้ยประกันภัย :</td>
                <td class="information-table-data">
                  {{ _.get(pricingInfo, 'familyDiscount') | formatNumber }}
                  บาท
                </td>
              </tr>
              <tr class="information-table-row">
                <td class="information-table-data">ยอดรวมที่ต้องชำระ :</td>
                <td class="information-table-data">
                  {{ _.get(pricingInfo, 'netPremium') | formatNumber }}
                  บาท
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div v-if="isErrorApplication">
          <h3 class="text-center" style="margin-top: 2em">ไม่พบเลขใบคำขอนี้ในระบบ!!</h3>
        </div>

        <div class="col-sm-12">
          <button
            v-if="_.get(applicationInfo, 'policyStatusId') === 1"
            type="button"
            class="btn btn-info"
            @click="issuedPolicy(applicationInfo)"
          >
            ออกกรมธรรม์
          </button>
        </div>
        <div class="col-sm-12" style="display:none">
          <hr />

          <label>Logging Out</label>
          <textarea class="form-control" readonly="readonly">
                    <TranID>2018111219504010048</TranID><TranDate>20181112</TranDate><TranTime>19:50:40</TranTime><TranType>Verify</TranType><RefNbr>6111300890</RefNbr><PolicyNbr></PolicyNbr><ClientCode></ClientCode><InsuredTitle>003</InsuredTitle><InsuredName>Nisachon Test</InsuredName><InsuredIDNbr>1100800942270</InsuredIDNbr><InsuredBranchNbr></InsuredBranchNbr><PolAddress>34 ตำบลเกาะกลาง</PolAddress><PolDistrict>01*02</PolDistrict><PolProvince>01</PolProvince><PolPostCode>81120</PolPostCode><DelAddress></DelAddress><DelDistrict></DelDistrict><DelProvince></DelProvince><DelPostCode></DelPostCode><Email>popati04@gmail.com</Email><MobilePhoneNbr>0617469292</MobilePhoneNbr><ContactPerson>Nisachon Test</ContactPerson><PlanCode>110$C-05$06$02$2PU$0100$00$2$0$0</PlanCode><EffectiveDate>20181113</EffectiveDate><EffectiveTime>00:00:00</EffectiveTime><CompInd>0</CompInd><CompEffectiveDate></CompEffectiveDate><CompEffectiveTime></CompEffectiveTime><VehicleType>110</VehicleType><Brand>MAZ</Brand><Model>MAZ*2099</Model><Displacement>1600</Displacement><Weight></Weight><Seat></Seat><YearMade>2013</YearMade><CarPlateNbr>2กด323</CarPlateNbr><CarPlateProvince>กจ</CarPlateProvince><ChassisNbr></ChassisNbr><DriverTitle1></DriverTitle1><DriverName1></DriverName1><DriverBirthDate1></DriverBirthDate1><DriverAge1></DriverAge1><DriverTitle2></DriverTitle2><DriverName2></DriverName2><DriverBirthDate2></DriverBirthDate2><DriverAge2></DriverAge2><SumInsured>100000.00</SumInsured><GrossPremium>1117.00</GrossPremium><StampAmount>5.00</StampAmount><VatAmount>78.54</VatAmount><TotalPremium>1200.54</TotalPremium><CompGrossPremium></CompGrossPremium><CompStampAmount></CompStampAmount><CompVatAmount></CompVatAmount><CompTotalPremium></CompTotalPremium><PaymentAmount>1200.54</PaymentAmount><PaymentChannel></PaymentChannel><PaymentCode></PaymentCode><PaymentRefNbr></PaymentRefNbr><PaymentDate></PaymentDate><PaymentTime></PaymentTime><PaymentApproveCode></PaymentApproveCode><PromotionCode></PromotionCode>
                    </textarea
          >

          <label>Logging In</label>
          <textarea class="form-control" readonly="readonly">
                    <TranID>2018111219554510048</TranID><TranType>Confirm</TranType><TranResult>SUCCESS</TranResult><ErrorCode></ErrorCode><ErrorDesc></ErrorDesc><RefNbr>6111300890</RefNbr><PolicyNbr>0010106111001781</PolicyNbr><PolicyURL>https://203.170.247.174/testws-ssl/pdf/0010106111001781_18579_MTUW1021H_W024990_PDF_8_1_0_1_1.PDF</PolicyURL>
                    </textarea
          >

          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

import API from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  name: 'issued_policy',
  data: () => ({
    healthQuestions: [
      '1. ท่านมีประกันชีวิต ประกันภัยสุขภาพ ประกันภัยโรคร้ายแรง โรคมะเร็ง หรือประกันภัยอุบัติเหตุ กับบริษัท ประกันภัยไทยวิวัฒน์ หรือบริษัทอื่นหรือไม่?',
      '2. ท่านเคยถูกปฏิเสธการขอเอาประกันชีวิต ประกันสุขภาพ ประกันภัยโรคร้ายแรง ประกันภัยอุบัติเหตุส่วนบุคคล หรือถูกปฏิเสธการต่ออายุสัญญาประกันภัย หรือถูกเรียกเก็บเบี้ยประกันภัยเพิ่ม หรือเปลี่ยนแปลงเงื่อนไข สำหรับการประกันภัยดังกล่าวหรือไม่',
      '3. ท่านเคยได้รับเชื้อ หรือมีอาการ หรือเคยได้รับการรักษา หรือขณะนี้รับการรักษาอยู่ หรือเคยได้รับการบอกเล่า จากแพทย์ด้วยโรคมะเร็ง เนื้องอกโรคสมอง/หลอดเลือดสมอง (Stoke) โรคตับ โรคเอดส์หรือมีเลือดบวกต่อไวรัส HIV โรคเบาหวาน โรคไต โรคหัวใจ/หลอดเลือด ความดันโลหิตสูง ไขมันในเลือดสูง โรคปอด โรคเลือด โรคถุงลม โป่งพอง ลำไส้อักเสบเรื้อรัง โรคทางระบบประสาท อัมพาต โรคกระดูกกระดูกสันหลัง โรคกล้ามเนื้อหรือโรคประจำตัว หรือมีความพิการ หรือโรคร้ายแรงอื่นๆ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)',
      '4. ท่านเคยได้รับคำแนะนำจากแพทย์ให้เข้ารับการรักษาจากการบาดเจ็บ การเจ็บป่วย หรือเข้ารับการผ่าตัด หรือมีโรคที่ ต้องอยู่ในความดูแลเป็นประจำของแพทย์ หรือเข้ารับการตรวจวินิจฉัยโรค เช่น การอัลตร้าซาวด์ เอ็กซเรย์ คอมพิวเตอร์ การตรวจด้วยคลื่นแม่เหล็กไฟฟ้า การส่งตรวจชิ้นเนื้อทางด้านพยาธิวิทยา การตรวจคลื่นหัวใจ การตรวจเลือด ตรวจปัสสาวะ/อุจจาระ หรือไม่ (รวมถึงการได้รับการรักษาแบบผู้ป่วยนอก)',
      '5. บิดา มารดา และ/หรือพี่น้อง ของผู้ขอเอาประกันภัยเคยได้รับการวินิจฉัยว่าป่วยเป็น หรือเสียชีวิตเนื่องจาก โรคหัวใจ/หลอดเลือด โรคมะเร็ง โรคสมอง/หลอดเลือดสมอง (Stroke) โรคตับ โรคเอดส์ วัณโรคหรือไม่?',
    ],
  }),
  computed: {
    ...mapGetters(['applicationInformation', 'isErrorApplication']),
    applicationInfo() {
      console.log(
        _.get(this.applicationInformation, 'applicationInformation.application', {}),
        'asdasdasd',
      )
      return _.get(this.applicationInformation, 'applicationInformation.application', {})
    },
    insuredPersonInfo() {
      return _.get(this.applicationInformation, 'applicationInformation.insuredPerson', {})
    },
    planPackageSchemeInfo() {
      return _.get(this.applicationInformation, 'applicationInformation.planPackageScheme', {})
    },
    paymentInfo() {
      return _.get(this.applicationInformation, 'applicationInformation.payment', {})
    },
    pricingInfo() {
      return _.get(this.applicationInformation, 'applicationInformation.pricing', {})
    },
    isHasFamilyQuotation() {
      return _.get(this.applicationInformation, 'applicationInformation.familyQuotation', {})
    },
    healthAnswerInfo() {
      const healthAnswers = this.applicationInfo.healthAnswers || ''
      const healthAnswersList = healthAnswers.split(',')

      return _.map(this.healthQuestions, (question, idx) => ({
        index: idx,
        question,
        answer: healthAnswersList[idx] !== '0' ? 'ใช่' : 'ไม่ใช่',
      }))
    },
    consentInsuredInformation() {
      return _.get(this.applicationInformation, 'consentInformation.insuredConsentImage', '')
    },
    consentPayerInformation() {
      return _.get(this.applicationInformation, 'consentInformation.payerConsentImage', '')
    },
  },
  watch: {
    applicationInfo: {
      handler(data) {
        this.getConsentInformation(data.applicationId)
        this.getPaymentInformation(data.applicationId)
      },
      deep: true,
    },
  },
  mounted() {
    const applicationId = this.$route.params.application_id

    this.getApplicationInformation(applicationId)
  },
  methods: {
    ...mapActions(['getApplicationInformation', 'getConsentInformation', 'getPaymentInformation']),
    issuedPolicy(result) {
      this.$swal({
        title: 'ต้องการออกกรมธรรม์?',
        text: 'ต้องการออกกรมธรรม์?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(res => {
        if (res.value) {
          this.generatePolicy(result)
        }
      })
    },
    generatePolicy({ applicationId, titleDesc, firstName, lastName }) {
      this.$swal({
        title: 'กรุณารอสักครู่',
        html: '<h5 class="m-b-md">กำลังทำการออกกรมธรรม์</h5><div class="loader"></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
      })

      this.$http
        .post(
          API.DOCUMENTS.GENERATE_POLICY(applicationId),
          {},
          {
            headers: {
              ...generateAuthorizationRequestHeader(),
            },
          },
        )
        .then(res => res.json())
        .then(
          response => {
            this.$swal({
              type: 'success',
              title: `ระบบ PV ได้ออกกรมธรรม์ให้กับ <br /> ${titleDesc}${firstName} ${lastName} <br /> เลขที่ใบคำขอ ${applicationId} เรียบร้อยแล้ว`,
            })

            this.init()
          },
          error => {
            this.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            })
          },
        )
    },
  },
}
</script>

<style lang="scss">
p {
  margin: 6px 0px !important;
}

.application-information {
  .appliciation-information-table {
    background-color: red;
    .information-table-row {
      .information-table-data:first-child {
        width: 200px;
      }
    }
  }
}

.health-question {
  margin-bottom: 8px;
}

.consent-image {
  width: 100%;
}

.highlight {
  color: #00a350;
}
</style>
